import { Box, Link, Typography } from "@mui/material";
import { getLocalizedMessage, SupportedLanguage } from "@pimo/pimo-l10n";

import { PRIVACY_POLICY_URL, TERMS_OF_USE_URL } from "../constants";

export function ModalLegalFooter({
  language,
}: {
  language: SupportedLanguage;
}) {
  return (
    <Box sx={{ px: 3, pb: 2 }}>
      <Typography variant="caption" color="text.secondary" display="block">
        {getLocalizedMessage(language, "legalFooter.priceExplanation")}
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block">
        <Link href={TERMS_OF_USE_URL} target="_blank" rel="noopener">
          {getLocalizedMessage(language, "legalFooter.termsOfUse")}
        </Link>
        {" · "}
        <Link href={PRIVACY_POLICY_URL} target="_blank" rel="noopener">
          {getLocalizedMessage(language, "legalFooter.privacyPolicy")}
        </Link>
      </Typography>
    </Box>
  );
}
